import React from 'react';

// Placeholder data for gallery images (replace URLs)
const galleryImages = [
  "https://skillsuprise.com/resources/images/g1.png",
  "https://skillsuprise.com/resources/images/g2.png",
  "https://skillsuprise.com/resources/images/g3.png",
  "https://skillsuprise.com/resources/images/g4.png",
  "https://skillsuprise.com/resources/images/g5.png",
  "https://skillsuprise.com/resources/images/g6.png",
  "https://skillsuprise.com/resources/images/g7.png",
  "https://skillsuprise.com/resources/images/g8.png",
  "https://skillsuprise.com/resources/images/g9.png",
];

// --- Internal CSS for all styling ---
const internalCSS = `
  /* --- Main Page Container --- */
  .gallery-page-container {
    /* Light blue/grey background from image */
    background-color: #f0f4f8; 
    font-family: 'Poppins', sans-serif;
    position: relative;
    overflow-x: hidden;
    padding-bottom: 100px; /* Space for the wave */
  }

  /* --- Title Section --- */
  .gallery-title-section {
    padding: 4rem 1rem 2rem 1rem;
    text-align: center;
  }

  .gallery-main-title {
    /* FIX: Changed font to match modern style */
    font-family: 'Poppins', sans-serif; 
    font-size: 3rem;
    font-weight: 700;
    color: #212529;
    margin-bottom: 0.5rem;
  }

  /* --- Image Grid Section --- */
  .gallery-grid-section {
    padding: 0 1rem 4rem 1rem;
  }

  .gallery-image-wrapper {
    /* FIX: Added blue border and padding */
    border: 4px solid #004a99; /* Blue border from your theme */
    padding: 8px; /* Padding to create "frame" */
    
    border-radius: 16px; /* Increased radius to match image */
    overflow: hidden;
    margin-bottom: 1.5rem;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    display: block;
    background-color: #fff; /* White background inside the frame */
  }

  .gallery-image {
    display: block;
    width: 100%;
    height: 200px; /* Give images a consistent height */
    object-fit: cover; /* Make images cover the area */
    transition: transform 0.3s ease;
    
    /* FIX: Added inner border-radius */
    border-radius: 8px; 
  }
  
  .gallery-image-wrapper:hover .gallery-image {
      transform: scale(1.03);
  }

  /* --- Wavy Bottom Section --- */
  .wavy-bottom-gallery-svg {
    position: absolute;
    bottom: -1px; /* Ensure it covers the bottom edge */
    left: 0;
    width: 100%;
    z-index: 0;
    pointer-events: none;
  }

  /* --- Responsive Adjustments --- */
  @media (max-width: 991.98px) { /* Tablets */
    .gallery-main-title { 
      font-size: 2.5rem;
    }
  }

  @media (max-width: 767.98px) { /* Mobile Devices */
     .gallery-page-container {
        padding-bottom: 80px;
     }
     .gallery-main-title {
       font-size: 2rem;
     }
     .gallery-image-wrapper {
        margin-bottom: 1rem;
        padding: 6px; /* Slightly smaller padding */
     }
     .gallery-image {
        height: 150px; /* Shorter height for mobile */
     }
  }
`;

const RecentGallery = () => {
  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="gallery-page-container">
        
        {/* --- 1. Title Section --- */}
        <div className="gallery-title-section">
          <h1 className="gallery-main-title">Recent Gallery</h1>
        </div>
        
        {/* --- 2. Image Grid Section --- */}
        <div className="gallery-grid-section">
          <div className="container">
            
            {/* FIX: Changed to row-cols-2.
              This creates 2 columns on ALL screen sizes,
              matching your mobile screenshot.
            */}
            <div className="row row-cols-2 g-3">
              
              {galleryImages.map((imageUrl, index) => (
                <div className="col" key={index}>
                  <div className="gallery-image-wrapper">
                    <img src={imageUrl} alt={`Gallery Image ${index + 1}`} className="gallery-image " />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* --- 3. Wavy Bottom SVG (Simplified) --- */}
        <svg 
          className="wavy-bottom-gallery-svg"
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 1440 320"
          style={{ height: '100px' }}
          preserveAspectRatio="none"
        >
           <path 
             fill="#f0f4f8" /* Match page background */
             fillOpacity="1" 
             d="M0,288L48,277.3C96,267,192,245,288,229.3C384,213,480,203,576,213.3C672,224,768,256,864,272C960,288,1056,288,1152,272C1248,256,1344,224,1392,208L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
           ></path>
         </svg>

      </div>
    </>
  );
};

export default RecentGallery;